import { computed } from 'vue'
import { useTemplate } from '../../../hooks/index'
export function useDisabled(templateData, menu) {
  const { getTemplateData, compileData } = useTemplate()
  const disabled = computed(() => {
    if (!menu.enableExp) {
      return false
    } else {
      const compile = getTemplateData(null, templateData.value)
      return !compileData(menu.enableExp, compile)
    }
  })

  return {
    disabled,
  }
}
